import { configureStore } from '@reduxjs/toolkit';
import ordersSlice from './sliceCreators/orderSlice';
import representativesSlice from './sliceCreators/representativesSlice';

export const store = configureStore({
  reducer: {
    orders: ordersSlice,
    representatives: representativesSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
